import { NzlifeQfaEnvironment } from './environment.model';

export const environment: NzlifeQfaEnvironment = {
  production: false,
  env: 'SIT',
  oAuthBaseUrl: 'https://chubblife--aiotest.sandbox.my.salesforce.com',
  oAuthBaseUrlIFA: 'https://adviser-sit.chubblife.co.nz',
  oAuthClientId: '3MVG99S6MzYiT5k9MbbY.Hmhx3OUMpI4F5D5xRJ.ZEbzP_itLCwUNe7sODjKBf3pfRSWeAVZE2KK5PgKwLwP1', // gitleaks:allow
  oAuthCallBackUrl: 'https://qfa-sit.chubblife.co.nz/callback',
  appInsightsConnString:
    'IngestionEndpoint=https://southeastasia-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/;ApplicationId=381103df-486c-45bc-a8f1-a450dcb29962', // gitleaks:allow
  instrumentationKey: 'f0e8958d-9f0c-402b-b208-af2a1ad3096c', // gitleaks:allow
  baseUrl: 'https://qfa-sit.chubblife.co.nz',
  baseApiUrl: 'https://qfa-sit.chubblife.co.nz/proxy/qfa',
  supportUrl: 'https://adviser-sit.chubblife.co.nz/s/contact-us',
};
